import * as React from "react";

import { FormItemVertical } from "../../../Forms/FormItemVertical";
import { Select } from "../../../../../components/Select";
import { Button } from "../../../../../components/Buttons";
import { intToString, stringToInt } from "../../../../../converters/converters";

import { ActionType } from "./flux";
import { groupActionsTranslationKeys } from "./groupEditNames";
import { Polyglot } from "../../../../../polyglot";

export interface GroupActionProps
{
    type: ActionType;
}

export interface AddGroupActionProps
{
    polyglot: Polyglot;
    isValid: boolean;
    selectedActionType: ActionType;
    
    commitAction: () => void;
    onGroupActionChanged: (type: ActionType) => void;
}

type GroupAction = React.ReactElement<GroupActionProps>;
export class AddGroupAction extends React.Component<AddGroupActionProps, any>
{
    constructor(props: Readonly<AddGroupActionProps>, context?: any)
    {
        super(props, context);
        this.state = { selectedActionType: null };
    }

    render()
    {
        const { polyglot, isValid, selectedActionType, onGroupActionChanged, commitAction } = this.props;

        const children = React.Children.toArray(this.props.children)
                                    .filter(child => (typeof child !== 'string') && (typeof child !== 'number'));
        const types = children.map((child, idx) => (child as GroupAction).props.type);
        const selectedGroupAction = children.find(child => (child as GroupAction).props.type === selectedActionType);

        return (
            <div className="col-md-6 col-xs-12">
                <FormItemVertical title={polyglot.t('vehicle.group_actions.title_select_action') + ':'}>
                    <Select className='form-control'
                        placeholder='---'
                        defaultValue={intToString(selectedActionType)}
                        items={types}
                        valueFn={actionType => intToString(actionType)}
                        titleFn={actionType => polyglot.t(groupActionsTranslationKeys.get(actionType))}
                        onChange={s => onGroupActionChanged(stringToInt(s.getValue()) as ActionType)}
                    />
                </FormItemVertical>
                { selectedGroupAction }
                { selectedGroupAction != null && <Button type='success' onClick={commitAction} disabled={!isValid}>{polyglot.t('button.add')}</Button> }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/AddGroupAction.tsx